import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchRelationship () {
  return fetch('/referenceData/getDropdownOptions?dropdown=personnel.emergencyContact.relationship')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the mode of transportation');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to Relationship. Please reload the page and try again');
    });
}

const useRelationship = () => {
  const value = useQuery({
    queryKey: ['useRelationship'],
    queryFn: fetchRelationship,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
  return value;
};

export default useRelationship;
